import React from "react"
import UserList from "../ui/UserList"
import UserSearch from "../ui/UserSearch"
import { User } from "../../ZeefTypes"

interface SocialLoadingState {
  followers: boolean
  following: boolean
  mutual: boolean
}

interface ZeefSidePanelProps {
  followers: User[]
  following: User[]
  mutualFollows: User[]
  onlineUsers: Set<string>
  loading: SocialLoadingState
  searchQuery: string
  searchResults: User[]
  isSearching: boolean
  isFollowingUser: boolean
  isUnfollowingUser: boolean
  unfollowingUserId: string | null
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onFollowUser: (userId: string) => void
  onUnfollowUser: (userId: string) => void
}

const ZeefSidePanel: React.FC<ZeefSidePanelProps> = ({
  followers,
  following,
  mutualFollows,
  onlineUsers,
  loading,
  searchQuery,
  searchResults,
  isSearching,
  isFollowingUser,
  isUnfollowingUser,
  unfollowingUserId,
  onSearchChange,
  onFollowUser,
  onUnfollowUser,
}) => {
  return (
    <div className="zeef-side-panel">
      <div className="side-panel-header">
        <h4>Social</h4>
      </div>

      <div className="side-panel-content">
        <UserList
          title="Followers"
          users={followers}
          isLoading={loading.followers}
          onlineUsers={onlineUsers}
          showUnfollow={false}
        />

        <UserList
          title="Following"
          users={following}
          isLoading={loading.following}
          onlineUsers={onlineUsers}
          showUnfollow={true}
          onUnfollow={onUnfollowUser}
          isUnfollowing={isUnfollowingUser}
          unfollowingUserId={unfollowingUserId}
        />

        <UserList
          title="Mutual Follows"
          users={mutualFollows}
          isLoading={loading.mutual}
          onlineUsers={onlineUsers}
          showUnfollow={true}
          onUnfollow={onUnfollowUser}
          isUnfollowing={isUnfollowingUser}
          unfollowingUserId={unfollowingUserId}
        />

        <UserSearch
          searchQuery={searchQuery}
          searchResults={searchResults}
          isSearching={isSearching}
          isFollowingUser={isFollowingUser}
          onSearchChange={onSearchChange}
          onFollowUser={onFollowUser}
        />
      </div>
    </div>
  )
}

export default ZeefSidePanel
